import React from "react";
import { Select } from "antd";
import { ORDER_STATUS_OPTIONS, ORDER_ITEM_STATUS_OPTIONS } from "../../constants/statusOptions";

const { Option } = Select;

/**
 * Durum seçimi için ortak Select component
 * @param {Object} props
 * @param {string} props.type - Durum tipi ("order" | "orderItem")
 * @param {string} props.value - Seçili değer
 * @param {Function} props.onChange - Değişiklik callback
 * @param {boolean} props.loading - Yükleme durumu
 * @param {boolean} props.disabled - Devre dışı durumu
 * @param {string} props.size - Select boyutu ("small" | "middle" | "large")
 * @param {number|string} props.width - Select genişliği
 * @param {Object} props.style - Ek stil özellikleri
 */
const StatusSelect = ({
  type = "orderItem",
  value,
  onChange,
  loading = false,
  disabled = false,
  size = "small",
  width = 120,
  style = {},
  ...rest
}) => {
  const options = type === "order" ? ORDER_STATUS_OPTIONS : ORDER_ITEM_STATUS_OPTIONS;

  return (
    <Select
      size={size}
      value={value}
      onChange={onChange}
      style={{ width, ...style }}
      loading={loading}
      disabled={disabled || loading}
      {...rest}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default StatusSelect;
